/**
 * Axios client مع interceptors
 */
import axios from "axios";

const api = axios.create({
  baseURL:         "/api/v1",
  withCredentials: true,
  headers:         { "Content-Type": "application/json" },
});

// Response interceptor — إعادة التوجيه عند 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // تجنب حلقة لا نهائية
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
